/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as ITokenRouteImport } from './routes/i.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const QTokenRoute = QTokenRouteImport.update({
  id: '/q/$token',
  path: '/q/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PTokenRoute = PTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ITokenRoute = ITokenRouteImport.update({
  id: '/i/$token',
  path: '/i/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/i/$token': typeof ITokenRoute
  '/p/$token': typeof PTokenRoute
  '/q/$token': typeof QTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/i/$token': typeof ITokenRoute
  '/p/$token': typeof PTokenRoute
  '/q/$token': typeof QTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/i/$token': typeof ITokenRoute
  '/p/$token': typeof PTokenRoute
  '/q/$token': typeof QTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/i/$token' | '/p/$token' | '/q/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/i/$token' | '/p/$token' | '/q/$token'
  id: '__root__' | '/' | '/i/$token' | '/p/$token' | '/q/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ITokenRoute: typeof ITokenRoute
  PTokenRoute: typeof PTokenRoute
  QTokenRoute: typeof QTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/q/$token': {
      id: '/q/$token'
      path: '/q/$token'
      fullPath: '/q/$token'
      preLoaderRoute: typeof QTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$token': {
      id: '/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$token': {
      id: '/i/$token'
      path: '/i/$token'
      fullPath: '/i/$token'
      preLoaderRoute: typeof ITokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ITokenRoute: ITokenRoute,
  PTokenRoute: PTokenRoute,
  QTokenRoute: QTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
